// extracted by mini-css-extract-plugin
export default {"modal":"CO-z","modalOverlay":"DO-z","outfitHeading":"EO-z"};